import { useState, useEffect, useRef } from 'react';
import { shoppingListService } from '../services/shoppingListService';

/**
 * Hook personalizado para manejar sugerencias de categorías con debounce
 */
export const useCategorySuggestions = (inputValue, delay = 250) => {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        // Limpiar timeout anterior
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        const trimmedValue = inputValue?.trim() || '';

        if (trimmedValue.length < 1) {
            setSuggestions([]);
            setShowSuggestions(false);
            return;
        }

        // Configurar nuevo timeout
        timeoutRef.current = setTimeout(async () => {
            setLoading(true);
            try {
                const categories = await shoppingListService.getCategorySuggestions(trimmedValue, 10);
                setSuggestions(categories);
                setShowSuggestions(categories.length > 0);
            } catch (error) {
                setSuggestions([]);
                setShowSuggestions(false);
            } finally {
                setLoading(false);
            }
        }, delay);

        // Cleanup function
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [inputValue, delay]);

    const hideSuggestions = () => {
        setShowSuggestions(false);
    };

    const selectSuggestion = (suggestion) => {
        setShowSuggestions(false);
        return suggestion;
    };

    return {
        suggestions,
        loading,
        showSuggestions,
        hideSuggestions,
        selectSuggestion
    };
};
